var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "draggable",
    _vm._b(
      {
        attrs: {
          disabled: _vm.disableDragging,
          draggable: ".draggable-calendar-list-item"
        },
        on: { update: _vm.update },
        model: {
          value: _vm.calendars,
          callback: function($$v) {
            _vm.calendars = $$v
          },
          expression: "calendars"
        }
      },
      "draggable",
      {
        swapThreshold: 0.3,
        delay: 500,
        delayOnTouchOnly: true,
        touchStartThreshold: 3
      },
      false
    ),
    [
      !_vm.isPublic
        ? _vm._l(_vm.calendars, function(calendar) {
            return _c("CalendarListItem", {
              key: calendar.id,
              staticClass: "draggable-calendar-list-item",
              attrs: { calendar: calendar }
            })
          })
        : _vm._l(_vm.calendars, function(calendar) {
            return _c("PublicCalendarListItem", {
              key: calendar.id,
              attrs: { calendar: calendar }
            })
          }),
      _vm._v(" "),
      _vm.loadingCalendars
        ? _c("CalendarListItemLoadingPlaceholder", {
            scopedSlots: _vm._u(
              [
                {
                  key: "footer",
                  fn: function() {
                    return undefined
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1163335532
            )
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }